import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { makeTransparentColor } from 'assets/styles/transparentColor';

import ButtonBase from './ButtonBase';

const RedButton = styled(ButtonBase)`
  background-color: ${theme.color.red};
  color: ${theme.color.white};

  &:hover {
    box-shadow: 0 0 10px ${makeTransparentColor(theme.color.red, 0.7)};
  }

  &:disabled {
    background-color: ${theme.color.disabled};
    box-shadow: none;
  }
`;

export default RedButton;
